/**
 * The agent load of each analytics server, one member for each server. The toolbox keeps the
 * progress and sends no frame when it changes, so the analytics server section reads it live.
 */

import type { Atom } from 'jotai';

import { queryAtoms } from '../queryAtoms';
import { api } from '@/api';
import type { AgentLoadSnapshot } from '@/types/agentLoad';

const loads = queryAtoms<string, AgentLoadSnapshot, AgentLoadSnapshot>({
    getRequestKey: (serverId): string => serverId,
    getPending: (): AgentLoadSnapshot => ({ progress: null, isLoading: true, error: null }),
    load: async (serverId): Promise<AgentLoadSnapshot> => ({
        progress: await api.getAgentLoadProgress(serverId),
        isLoading: false,
        error: null,
    }),
    merge: (_previousSnapshot, page): AgentLoadSnapshot => page,
});

/** The agent load of the server; while mounted, it polls every `intervalMs` or faster. */
export function agentLoadAtom(serverId: string, intervalMs: number): Atom<AgentLoadSnapshot> {
    return loads.getLive(serverId, intervalMs);
}

/** What a reader gets while its server is offline: the relay cannot reach it, so none loads. */
export const noAgentLoadAtom: Atom<AgentLoadSnapshot> = loads.getMember(null);
